'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// header

var Projected = function Projected(props) {
    var display = _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', {
            className: 'gold-text fas fa-question-circle hover',
            style: { paddingLeft: props.paddingLeft ? +props.paddingLeft : 0 }
        })
    );

    return display;
};

exports.default = Projected;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/UI/Projected.js
// module id = 365
// module chunks = 0